// @flow
import styled from "styled-components";

export const Wrapper = styled.div`
    position: relative;
`;

export const Photo = styled.div`
    position: absolute;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    height: 100vh;
    width: 100%;
`;

export const Spinner = styled.div`
    background-color: #000;
    position: absolute;
    height: 100vh;
    width: 100%;
    z-index: 0;
    text-align: center;
    vertical-align: middle;
    line-height: 100vh;
    color: #fff;

    & > svg {
        opacity: 0.5;
        animation: rotate 2s linear infinite;
        @keyframes rotate {
            100% {
                transform: rotate(360deg);
            }
        }
    }
`;

export const Overlay = styled.div`
    opacity: 0;
    width: 100%;
    height: 100%;
    transition: opacity 0.25s ease-in-out;

    &:hover {
        opacity: 1;
    }
`;

export const Detail = styled.div`
    color: #fff;
    position: absolute;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.1);
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
`;
export const DetailTop = styled.div`
    color: #fff;
    position: absolute;
    top: 0;
    background-color: rgba(0, 0, 0, 0.1);
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
`;

export const Date = styled.div`
    text-align: right;
`;

export const Title = styled.div`
    font-weight: bold;
`;

export const Description = styled.div``;

export const IconButton = styled.div`
    color: #fff;
    opacity: 0.5;
    line-height: 100vh;
    vertical-align: middle;
    position: absolute;
    cursor: pointer;

    &:hover {
        opacity: 1;
    }
`;

export const BackButton = IconButton.extend`
    width: 10%;
    min-width: 50px;
`;

export const NextButton = IconButton.extend`
    right: 0;
    min-width: 50px;
    width: 75%;
    text-align: right;
`;

export const PlayButton = IconButton.extend`
    position: absolute;
    top: 0;
    text-align: center;
    width: 100px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;

    & > svg {
        vertical-align: middle;
    }
`;



// WEBPACK FOOTER //
// ./src/photo-dialog/photo-card/styled.js